var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/iframe-component.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if((lineno = 0, colno = 8, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["entry.fields.src"]))) {
output += "\n\n    <iframe data-index=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "moduleIndex"), env.opts.autoescape);
output += "\n            data-qa-iframe=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "moduleIndex"), env.opts.autoescape);
output += "\"\n            allowTransparency=\"true\"\n            src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"src"), env.opts.autoescape);
output += "\"\n            marginheight=\"0\" marginwidth=\"0\" scrolling=\"no\" frameborder=\"0\"\n            style=\"width:100%; max-width:";
output += runtime.suppressValue((lineno = 7, colno = 46, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["entry.fields.width","100%"])), env.opts.autoescape);
output += "; height:";
output += runtime.suppressValue((lineno = 7, colno = 91, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["entry.fields.height","100%"])), env.opts.autoescape);
output += ";\">\n    </iframe>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/iframe-component.j2"] , dependencies)